<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <el-button size="small" type="primary" @click="show('新增')"
              >新增租户</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="416" size="small">
        <el-table-column label="租户名称" prop="tenantName" />
        <el-table-column prop="" label="合约开关">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.contractSwitch"
              @change="handleUpdateMarkStatus(scope.row.id, $event, 'contract')"
              active-color="#13ce66"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="" label="资金费率开关">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.fundSwitch"
              @change="
                handleUpdateMarkStatus(scope.row.id, $event, 'fundSwitch')
              "
              active-color="#13ce66"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="" label="杠杆开关">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.leverSwitch"
              @change="handleUpdateMarkStatus(scope.row.id, $event, 'lever')"
              active-color="#13ce66"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="" label="现货开关">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.spotSwitch"
              @change="handleUpdateMarkStatus(scope.row.id, $event, 'spot')"
              active-color="#13ce66"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="" label="otc开关">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.otcSwitch"
              @change="handleUpdateMarkStatus(scope.row.id, $event, 'otc')"
              active-color="#13ce66"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="120px"
        >
          <el-form-item label="租户名称" prop="" :required="true">
            <el-input v-model="formData.tenantName"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tabList: [],
      dialogVisible: false,
      title: "新增",
      formData: {
        id: null,
        tenantName: "",
      },
      switchFnObj: {
        contract: api.updateContract,
        lever: api.updateLever,
        spot: api.updateSpot,
        otc: api.updateOtc,
        fundSwitch: api.updateFund,
      },
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    handleUpdateMarkStatus(id, val, type) {
      this.switchFnObj[type]({ tenantId: id, status: val }).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功！");
          this.handleSearch();
        }
      });
    },
    handleSearch() {
      api.getTenantList().then((res) => {
        if (res.code == 0) {
          const { data } = res;
          this.tabList = data;
        }
      });
    },

    show(str, row) {
      if (row) {
        this.formData = {
          id: row.id,
          tenantName: row.tenantName,
        };
      } else {
        this.formData = { id: null, tenantName: "" };
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = { id: null, tenantName: "" };
    },
    handleSave() {
      if (!this.formData.tenantName || this.formData.tenantName === "") {
        return this.$message.error("请输入租户名称");
      }

      const url = this.title === "新增" ? "addTenant" : "updaTenant";
      const payload =
        this.title === "新增"
          ? { tenantName: this.formData.tenantName }
          : { id: this.formData.id, tenantName: this.formData.tenantName };
      api[url](payload).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
